import { Grid } from "@mui/material";
import * as React from "react";
import { GetChannelQuery_channel } from "../Overview/__generated__/GetChannelQuery";
import ChannelPlayoutSecurityGeoBlocking from "./ChannelPlayoutSecurityGeoBlocking";
import ChannelPlayoutTokenSecurity from "./ChannelPlayoutTokenSecurity";
import { BlockingModeEnum } from "../../../__generated__/globalTypes";
import ChannelPlayoutSecurityIPBlocking from "./ChannelPlayoutSecurityIPBlocking";

interface Props {
    channel: GetChannelQuery_channel;
    playoutId: string;
}

export interface PlayoutSecuritySettings {
    channelId: string;
    parentChannelId: string;
    isAlias: boolean;
    geoBlocking: {
        enabled: boolean;
        countries: string[];
        mode: BlockingModeEnum;
    };
    ipBlocking: {
        enabled: boolean;
        cidrs: string[];
        mode: BlockingModeEnum;
    };
    jwt: {
        enabled: boolean;
        version: number;
        keys: { id: string }[];
    };
}

function ChannelPlayoutSecurity({ channel, playoutId }: Props) {
    const isAlias = channel.channelId !== playoutId;

    const publicationConfig = isAlias
        ? channel.aliases.find((a) => a.channelId === playoutId)!.publicationConfig
        : channel.publicationConfig;

    const securitySettings: PlayoutSecuritySettings = {
        parentChannelId: channel.channelId,
        channelId: playoutId,
        isAlias,
        geoBlocking: {
            enabled: publicationConfig?.geoBlocking?.enabled ?? false,
            countries: publicationConfig?.geoBlocking?.countries ?? [],
            mode: publicationConfig?.geoBlocking?.mode ?? BlockingModeEnum.whitelist,
        },
        ipBlocking: {
            enabled: publicationConfig?.ipBlocking?.enabled ?? false,
            cidrs: publicationConfig?.ipBlocking?.cidrs ?? [],
            mode: publicationConfig?.ipBlocking?.mode ?? BlockingModeEnum.whitelist,
        },
        jwt: {
            enabled: publicationConfig?.tokenSecurity.enabled === true,
            keys: publicationConfig?.tokenSecurity.version === 2 ? publicationConfig.tokenSecurity.keys ?? [] : [],
            version: publicationConfig?.tokenSecurity.version ?? 2,
        },
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ChannelPlayoutSecurityGeoBlocking
                    securitySettings={securitySettings}
                    organizationId={channel.organizationId}
                />
            </Grid>
            <Grid item xs={12}>
                <ChannelPlayoutSecurityIPBlocking
                    securitySettings={securitySettings}
                    organizationId={channel.organizationId}
                />
            </Grid>
            <Grid item xs={12}>
                <ChannelPlayoutTokenSecurity settings={securitySettings} organizationId={channel.organizationId} />
            </Grid>
        </Grid>
    );
}

export default ChannelPlayoutSecurity;
